module.exports = __webpack_public_path__ + "static/media/LandingPage-Alert.ed52316f.png";